import React, { Component, Fragment } from 'react';
import classname from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { forms as Forms } from '@breezeway/brzw-components';

import { COLUMN_SIZES } from '../constants';

import './flex_table_row.scss';

export const CLASS_NAME = 'flex-table-row';

class FlexTableRow extends Component {
  constructor(props) {
    super(props);

    this.renderCell = this.renderCell.bind(this);
    this.renderEndMessage = this.renderEndMessage.bind(this);
  }

  static renderDefaultCell(value) {
    const cellIsNotEmpty = !_.isEmpty(value) && !_.isObject(value);
    return cellIsNotEmpty ? <span>{value}</span> : <span className={`${CLASS_NAME}__empty`} />;
  }

  renderCell(column, iterated) {
    const { data, index, fixedColumnName } = this.props;

    const width = _.get(column, 'width', COLUMN_SIZES.SM);
    const accessor = _.get(column, 'accessor', '');
    const props = _.get(column, 'customProps', {});
    const name = _.get(column, 'name', '');
    const cellClassModificator = _.get(column, 'cellClassModificator', 'default');

    const customCell = _.get(column, 'renderCustomCell');
    const cellValue = _.get(data, accessor, data);
    const cellContent = customCell
      ? customCell(cellValue, props, index)
      : FlexTableRow.renderDefaultCell(cellValue, index);

    return (
      <div
        className={classname(`${CLASS_NAME}__column ${CLASS_NAME}__${cellClassModificator}`, {
          '-with-sticky': fixedColumnName === iterated,
        })}
        key={`${name}-${index}`}
        style={{ width }}
      >
        {cellContent}
      </div>
    );
  }

  renderEndMessage() {
    const { style, isLast } = this.props;
    return (
      isLast && (
        <div className={`${CLASS_NAME}__column ${CLASS_NAME}__column--end-message`} style={style}>
          You’ve reached the end
        </div>
      )
    );
  }

  renderSelectCell() {
    const { index, isSelected, onChangeSelected } = this.props;
    return (
      <div
        key={`select-cell-${index}`}
        className={`${CLASS_NAME}__column ${CLASS_NAME}--select-cell`}
      >
        <Forms.CheckboxInput
          name={`select-cell-${index}-${isSelected}`}
          onChange={onChangeSelected}
          value={isSelected}
        />
      </div>
    );
  }

  render() {
    const { displayEndMessage, isSelected, style, columns, isLast, selectable } = this.props;

    return (
      <Fragment>
        <div
          style={style}
          className={classname(CLASS_NAME, {
            '-last-item': isLast,
            '-selected-item': isSelected,
          })}
        >
          {selectable && this.renderSelectCell()}
          {_.map(columns, (column, iterated) => this.renderCell(column, iterated))}
        </div>
        {displayEndMessage && this.renderEndMessage()}
      </Fragment>
    );
  }
}

FlexTableRow.propTypes = {
  columns: PropTypes.shape({}),
  data: PropTypes.shape({}),
  displayEndMessage: PropTypes.bool,
  fixedColumnName: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLast: PropTypes.bool,
  isSelected: PropTypes.bool,
  onChangeSelected: PropTypes.func,
  selectable: PropTypes.bool,
  style: PropTypes.any,
};

FlexTableRow.defaultProps = {
  isSelected: false,
  selectable: false,
};

export default FlexTableRow;
